// src/components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Brand Section */}
        <div className="footer-section brand">
          <h2 className="footer-logo">GKM Invest</h2>
          <p>
            Redefining modern living through secure and seamless 
            apartment management solutions.
          </p>
          <div className="social-links">
            <a href="#" aria-label="Facebook">FB</a>
            <a href="#" aria-label="Twitter">TW</a>
            <a href="#" aria-label="LinkedIn">LN</a>
          </div>
        </div>

        {/* Navigation Links */}
        <div className="footer-section links">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/RentalLandingPage">For Sale</Link></li>
            <li><Link to="/Our_services">For Rent</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section contact">
          <h4>Get In Touch</h4>
          <p><span>📧</span> gkminvests@gmail.com</p>
          <p><span>📞</span> +250 787 288 639</p>
          <p><span>📞</span> +250 784 139 738</p> 
          <p><span>📍</span> kibagabaga, Kigali, Rwanda</p>
        </div>

        {/* Newsletter / CTA */}
        <div className="footer-section contact" style={{ marginBottom: '20px' }}>
  <h4 style={{ 
    fontFamily: "var(--serif-font)", 
    color: "var(--accent-gold)", 
    marginBottom: '20px',
    fontSize: '1.2rem'
  }}>
    Social Media
  </h4>
  
  <div className="social-links-list" style={{ 
    display: 'flex', 
    flexDirection: 'column', 
    gap: '15px' 
  }}>
    
    {/* WhatsApp Link */}
    <a 
      href="https://wa.me/250787288639" 
      target="_blank" 
      rel="noreferrer" 
      style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '12px', 
        textDecoration: 'none', 
        color: '#ffffff', 
        fontSize: '0.9rem' 
      }}
    >
      <a 
      href="https://wa.me/250787288639" 
      target="_blank" 
      rel="noreferrer" 
      style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '12px', 
        textDecoration: 'none', 
        color: '#ffffff', 
        fontSize: '0.9rem' 
      }}
    >

    </a>
      <img 
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" 
        alt="WhatsApp" 
        style={{ width: '24px', height: '24px', objectFit: 'contain' }} 
      />
      <span>WhatsApp: 250787288639</span>
    </a>

    {/* YouTube Link */}
    {/* YouTube */}
  <a
    href="https://www.youtube.com/@LaSplendideApartment-v8h"
    target="_blank"
    rel="noreferrer"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "12px 16px",
      background: "#FF0000",
      borderRadius: "10px",
      textDecoration: "none",
      color: "#fff",
      fontWeight: "bold",
      transition: "0.3s",
      boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
    }}
  >
    <img
      src="https://cdn-icons-png.flaticon.com/512/1384/1384060.png"
      alt="YouTube"
      style={{ width: "28px", height: "28px" }}
    />
    <span>YouTube Channel</span>
  </a>

  {/* Facebook */}
  <a
    href="https://www.facebook.com/search/top?q=gkm%20invest%20photos&__stsd__=eyJwcmltYXJ5Ijp7InR5cGUiOiJUWVBFQUhFQURfUEVPUExFX0VOVElUSUVTIn19"
    target="_blank"
    rel="noreferrer"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "12px 16px",
      background: "#1877F2",
      borderRadius: "10px",
      textDecoration: "none",
      color: "#fff",
      fontWeight: "bold",
      transition: "0.3s",
      boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
    }}
  >
    <img
      src="https://cdn-icons-png.flaticon.com/512/733/733547.png"
      alt="Facebook"
      style={{ width: "28px", height: "28px" }}
    />
    <span>Facebook Page</span>
  </a>

  </div>
</div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} GKM Invest. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;